import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { PayloadAction } from '@reduxjs/toolkit';
import {
  getCoolerTransactions,
  getCoolerTransactionsSuccess,
  getCoolerTransactionsFailure,
  getCoolerTransaction,
  getCoolerTransactionSuccess,
  getCoolerTransactionFailure,
  resetCoolerTransaction,
} from '@/store/slices/coolerTransaction.slice';
import { fetchCoolerTransaction, fetchCoolerTransactions } from '@/services/coolerTransaction';
import {
  ICoolerSingleTransactionResponse,
  ICoolerTransaction,
  ICoolerTransactionResponse,
  IFetchCoolerTransactions,
} from '@/pages/CoolerTransaction/coolerTransaction.interface';
import { isSameRequestParams } from '@/utils/requestParamsChecker';

function* fetchCoolerTransactionsSaga(
  action: PayloadAction<ICoolerTransaction>,
): Generator<any, void, any> {
  try {

    const response = (yield call(
      fetchCoolerTransactions as any,
      action.payload,
    )) as AxiosResponse<ICoolerTransactionResponse>;
    if (response?.data?.success) {
      yield put(getCoolerTransactionsSuccess(response.data as any));
    } else {
      yield put(getCoolerTransactionsFailure(response?.data as any));
    }
  } catch (error) {
    yield put(getCoolerTransactionsFailure((error as any)?.response?.data?.message));
  }
}

function* fetchSingleCoolerTransactionSaga(
  action: PayloadAction<ICoolerTransaction>,
): Generator<any, void, any> {
  try {
    const response = (yield call(
      fetchCoolerTransaction as any,
      action.payload,
    )) as AxiosResponse<ICoolerSingleTransactionResponse>;
    if (response?.data?.success) {
      yield put(getCoolerTransactionSuccess(response.data as any));
    } else {
      yield put(getCoolerTransactionFailure(response?.data as any));
    }
  } catch (error: any) {
    yield put(getCoolerTransactionFailure(error?.response?.data));
  }
}

function* coolerTransactionSaga() {
  yield takeLatest(getCoolerTransactions.type, fetchCoolerTransactionsSaga);
  yield takeLatest(getCoolerTransaction.type, fetchSingleCoolerTransactionSaga)
}

export default coolerTransactionSaga;
